const state = {
  vimeoStatusCode: null,
  videoData: null,
};

const mutations = {
  SET_VIDEO_DATA(state, video) {
    state.videoData = video;
  },
  SET_VIDEO_STATUS_CODE(state, status) {
    state.vimeoStatusCode = status;
  },
};

const actions = {};

const getters = {
  stateVideoData: (state) => {
    return state.videoData;
  },
  stateVimeoStatusCode: (state) => {
    return state.vimeoStatusCode;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
